import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  Box,
  FormControl,
  FormLabel,
  InputGroup,
  InputRightElement,
  Input,
  Stack,
  FormHelperText,
  Text,
  Flex,
  Img,
  Button,
  Textarea,
  Select
} from "@chakra-ui/react";
import Multiselect from "multiselect-react-dropdown";
import NextLink from "next/link";
import Link from "next/link";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import useCustomToast from "hooks/useCustomToast";
import StarEle from "@/utils/StarElement"
import PhoneNumberInput from "@/utils/PhoneNumberInput";
import { isValidPhoneNumber } from 'react-phone-number-input/input';
import Spinner from "@/components/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { signup } from "store/authSlice";
import firebase from 'firebase';
import { useAuth } from "@/lib/auth";
import CityStateSelector from "@/components/CityStateSelector";

const Signup = () => {
  const dispatch = useDispatch();
  const firestore = firebase.firestore();
  const db = firestore;
  const { authenticateWithToken } = useAuth();
  const authState = useSelector((state) => state.auth);
  const { industries, careers, loading } = authState;
  const [allIndustries, setallIndustries] = useState(industries?.filter(ind => ind?.status === true))
  const [allServices, setallServices] = useState(careers);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    career_focus: [],
    industry: [],
    password: "",
    confirm_password: "",
    state: "",
    city: "",
    otherCareers: null
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordCon, setShowPasswordCon] = useState(false);
  const [IsLoading, setIsLoading] = useState(loading);
  const toast = useCustomToast();
  const router = useRouter();
  const search = router?.query.isNew;
  useEffect(() => {
    setallIndustries(industries?.filter(ind => ind?.status === true));
    setallServices(careers);
  }, [industries]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    if (name == "password") {
      setFormData({ ...formData, password: value.trim("") })
    } else if (name == "confirm_password") {
      setFormData({ ...formData, confirm_password: value.trim("") })
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      switch (name) {
        case "first_name":
          if (!value) {
            newErrors.first_name = "First name is required";
          } else {
            delete newErrors.first_name;
          }
          break;
        case "email":
          if (!value) {
            newErrors.email = "Email is required";
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            newErrors.email = "Email is invalid";
          } else {
            delete newErrors.email;
          }
          break;
        case "phone_number":
          if (!value) {
            newErrors.phone_number = "Phone number is required";
          } else if (value && !isValidPhoneNumber('+1' + value)) {
            newErrors.phone_number = "Invalid phone number";
          } else {
            setFormData({ ...formData, 'phone_number': value });
            delete newErrors.phone_number;
          }
          break;
        case "career_focus":
          if (!value[0]) {
            newErrors.career_focus = "Career focus is required";
          } else {
            delete newErrors.career_focus;
          }
          break;
        case "otherCareers":
          if (!value[0]) {
            newErrors.otherCareers = "Career focus is required";
          } else {
            delete newErrors.otherCareers;
          }
          break;
        case "industry":
          if (!value[0]) {
            newErrors.industry = "Industry is required";
          } else {
            delete newErrors.industry;
          }
          break;
        // case "password":
        //   if (!value) {
        //     newErrors.password = "Password is required";
        //   } else if (value.length < 8) {
        //     newErrors.password = "Password must have atleast 8 characters";
        //   } else {
        //     if (formData.confirm_password && value !== formData.confirm_password) {
        //       newErrors.confirm_password = "Confirm password does not match";
        //     }
        //     delete newErrors.password;
        //   }
        //   break;
        case "password":
          if (!value) {
            newErrors.password = "Password is required";
          } else if (value.length < 12) {
            newErrors.password = "Password must have at least 12 characters";
          } else if (!/[A-Z]/.test(value)) {
            newErrors.password = "Password must include at least one uppercase letter";
          } else if (!/[a-z]/.test(value)) {
            newErrors.password = "Password must include at least one lowercase letter";
          } else if (/@/.test(value)) {
            newErrors.password = "Password cannot contain '@'";
          } else if (
            formData.email &&
            value.toLowerCase().includes(formData.email.split("@")[0].toLowerCase())
          ) {
            newErrors.password = "Password cannot contain your email name";
          } else {
            // confirm password check
            if (formData.confirm_password && value !== formData.confirm_password) {
              newErrors.confirm_password = "Confirm password does not match";
            }
            delete newErrors.password;
          }
          break;

        case "confirm_password":
          if (!value) {
            newErrors.confirm_password = "Confirm password is required";
          } else if (value !== formData.password) {
            newErrors.confirm_password = "Confirm password does not match";
          }
          else {
            delete newErrors.confirm_password;
          }
          break;
        case "state":
          if (!value) {
            newErrors.state = "State is required";
          } else {
            delete newErrors.state;
          }
          break;
        case "city":
          if (!value) {
            newErrors.city = "City is required";
          } else {
            delete newErrors.city;
          }
          break;
        default:
          break;
      }
      return newErrors;
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});

      // Check if city and state are selected and if the city is available
      if (!formData.state || !formData.city) {
        toast({
          title: "Location required",
          description: "Please select your state and city to proceed.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const resultAction = await dispatch(
        signup(formData)
      );

      if (signup.fulfilled.match(resultAction)) {
        await authenticateWithToken(resultAction.payload.data.customToken);
        await db.collection(`users`)
          .doc(resultAction.payload.data._id)
          .set({
            uid: resultAction.payload.data._id,
            first_name: formData?.first_name,
            last_name: formData?.last_name,
            email: formData?.email,
            phone_number: formData?.phone_number,
            state: formData?.state,
            city: formData?.city,
          });
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          career_focus: [],
          industry: [],
          password: "",
          confirm_password: "",
          state: "",
          city: "",
          otherCareers: null
        });
        toast(
          "Account created.",
          "success",
          "Your account has been created successfully.",
          true
        );
        router.replace(`/signup-success?isNew=${true}`);
      } else {
        toast(resultAction.payload || 'Signup failed', 'error', '', true);
      }
    }
  };

  const validateForm = () => {
    const validationErrors = {};
    if (!formData.first_name) {
      validationErrors.first_name = "First name is required";
    }
    if (!formData.email) {
      validationErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)) {
      validationErrors.email = "Email is invalid";
    }
    if (!formData.phone_number) {
      validationErrors.phone_number = "Phone number is required";
    } else if (!isValidPhoneNumber('+1' + formData.phone_number)) {
      validationErrors.phone_number = "Invalid phone number";
    }
    if (formData.career_focus?.length === 0 && !formData.otherCareers) {
      validationErrors.career_focus = "Career focus is required";
    }
    if (formData.industry?.length === 0) {
      validationErrors.industry = "Industry is required";
    }
    // if (!formData.password) {
    //   validationErrors.password = "Password is required";
    // } else if (formData.password.length < 12) {
    //   validationErrors.password = "Password must have atleast 12 characters";
    // }
    // Password rules
    if (!formData.password) {
      validationErrors.password = "Password is required";
    } else if (formData.password.length < 12) {
      validationErrors.password = "Password must have at least 12 characters";
    } else if (!/[A-Z]/.test(formData.password)) {
      validationErrors.password = "Password must include at least one uppercase letter";
    } else if (!/[a-z]/.test(formData.password)) {
      validationErrors.password = "Password must include at least one lowercase letter";
    } else if (/@/.test(formData.password)) {
      validationErrors.password = "Password cannot contain '@'";
    } else if (
      formData.email &&
      formData.password
        .toLowerCase()
        .includes(formData.email.split("@")[0].toLowerCase())
    ) {
      validationErrors.password = "Password cannot contain your email name";
    }
    if (!formData.confirm_password) {
      validationErrors.confirm_password = "Confirm password is required";
    } else if (formData.password !== formData.confirm_password) {
      validationErrors.confirm_password = "Confirm password does not match";
    }
    if (!formData.state) {
      validationErrors.state = "State is required";
    }
    if (!formData.city) {
      validationErrors.city = "City is required";
    }
    return validationErrors;
  };

  const options = [
    { name: "Interview Prepration", id: 1 },
    { name: "Career Guidance", id: 2 },
  ];
  const onSelect = (selectedList, selectedItem) => {
    setFormData({ ...formData, ["career_focus"]: selectedList });
    setErrors({ ...errors, career_focus: null })
  };
  const onRemove = (selectedList, removedItem) => {
    setFormData({ ...formData, ["career_focus"]: selectedList });
  };
  const dependentCareerIndustry = (seslectedList) => {
    const industriesToFilter = seslectedList.map(filter => filter.name);
    setallServices([...careers?.filter(c => industriesToFilter?.includes(c?.industry)), { name: 'Other' }]);
  }
  const onSelectIndustry = (selectedList, selectedItem) => {
    setFormData({ ...formData, ["industry"]: selectedList });
    setErrors({ ...errors, industry: null })
    dependentCareerIndustry(selectedList);
  };
  const onRemoveIndustry = (selectedList, removedItem) => {
    setFormData({ ...formData, ["industry"]: selectedList });
    dependentCareerIndustry(selectedList);
  };

  const handleKeyDown = (e) => {
    const allowedKeys = [
      " "
    ];

    if (allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Flex
      className="signup-main-Box-wrap"
      as="main"
      w={["100%", "100%", "100%", "100%"]}
    >
      <Box className="container mx-auto">
        {IsLoading && <Spinner />}
        <Box className="login-page-container">
          <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
            <Box className="login-form-wrapper">
              <h1 className="heading-color text-center mb-[30px]">
                Create New Account
              </h1>
              <form onSubmit={handleSubmit} className="authform">
                <Stack className="gap-0">
                  <Stack gap={"0 !important"}>
                    <FormControl className="mb-4" isInvalid={errors.first_name}>
                      <FormLabel className="form-label">First Name<StarEle /></FormLabel>
                      <Input
                        className="form-control"
                        placeholder="Enter First Name"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                      />
                      {errors.first_name && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.first_name}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl className="mb-4" isInvalid={errors.last_name}>
                      <FormLabel className="form-label">Last Name</FormLabel>
                      <Input
                        className="form-control"
                        placeholder="Enter Last Name"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                      />
                    </FormControl>
                    <FormControl className="mb-4" isInvalid={errors.email}>
                      <FormLabel className="form-label">Email<StarEle /></FormLabel>
                      <Input
                        placeholder="Enter Email"
                        className="form-control"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.email}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      className="mb-4"
                      isInvalid={errors.phone_number}
                    >
                      <FormLabel className="form-label">Phone Number<StarEle /></FormLabel>
                      <PhoneNumberInput
                        value={formData.phone_number}
                        handleChange={handleInputChange}
                      />
                      {errors.phone_number && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.phone_number}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl className="mb-4" isInvalid={errors.industry}>
                      <FormLabel className="form-label">Industry<StarEle /></FormLabel>
                      <Multiselect
                        className="form-select"
                        options={allIndustries}
                        selectedValues={formData?.industry}
                        onSelect={onSelectIndustry}
                        onRemove={onRemoveIndustry}
                        displayValue="name"
                      />
                      {errors.industry && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.industry}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      className="mb-4"
                      isInvalid={errors.career_focus}
                    >
                      <FormLabel className="form-label">Career Focus<StarEle /></FormLabel>
                      <Multiselect
                        className="form-select"
                        options={allServices}
                        selectedValues={formData?.career_focus}
                        onSelect={onSelect}
                        onRemove={onRemove}
                        disable={formData?.industry?.length === 0}
                        displayValue="name"
                        placeholder={formData?.industry?.length === 0 ? "Before Select Industry" : "Select"}
                      />
                      {errors.career_focus && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.career_focus}
                        </FormHelperText>
                      )}
                    </FormControl>
                    {formData?.career_focus?.find(r => r?.name === 'Other') && <FormControl className="mb-4">
                      <FormLabel className="form-label">Other Career Focus<StarEle /></FormLabel>
                      <Textarea
                        rows={2}
                        className="form-control"
                        placeholder="Java,Python,Ruby"
                        name="otherCareers"
                        defaultValue={formData?.otherCareers}
                        onChange={handleInputChange}
                      />
                      {errors?.otherCareers && <FormHelperText style={{ color: "red" }}>
                        {errors?.otherCareers}
                      </FormHelperText>}
                    </FormControl>}
                    <FormControl className="mb-4" isInvalid={errors.password}>
                      <FormLabel className="form-label">Password<StarEle /></FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Enter Password"
                          className="form-control"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onKeyDown={handleKeyDown}
                          onChange={handleInputChange}
                        />
                        <InputRightElement className="eye-btn-wrapper">
                          <Button
                            backgroundColor="rgb(239,239,239)"
                            h="1.75rem"
                            size="sm"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {errors.password && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.password}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      className="mb-4"
                      isInvalid={errors.confirm_password}
                    >
                      <FormLabel className="form-label">
                        Confirm Password<StarEle />
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Enter Confirm Password"
                          className="form-control"
                          type={showPasswordCon ? "text" : "password"}
                          name="confirm_password"
                          value={formData.confirm_password}
                          onChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                        />
                        <InputRightElement className="eye-btn-wrapper">
                          <Button
                            backgroundColor="rgb(239,239,239)"
                            h="1.75rem"
                            size="sm"
                            onClick={() => setShowPasswordCon(!showPasswordCon)}
                          >
                            {showPasswordCon ? <FaRegEye /> : <FaRegEyeSlash />}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {errors.confirm_password && (
                        <FormHelperText style={{ color: "red" }}>
                          {errors.confirm_password}
                        </FormHelperText>
                      )}
                    </FormControl>

                    <CityStateSelector
                      formData={formData}
                      setFormData={setFormData}
                      errors={errors}
                      setErrors={setErrors}
                    />

                    <Text className="my-[20px]">
                      By creating an account, I agree to SkilSoar's{" "}

                      <Link target="_blank" href="/term-and-conditions" className="underline text-hover">
                        Terms & Conditions
                      </Link>{" "}
                      and{" "}
                      <Link target="_blank" href="/privacy-policy" className="underline text-hover">
                        {" "}
                        Privacy Policy.
                      </Link>
                    </Text>

                    <Button fullwidth type="submit" className="dark-blue-btn mt-4" isDisabled={IsLoading}>
                      Create Account
                    </Button>
                  </Stack>
                </Stack>
              </form>
              <Box className="create-account-link mt-[30px]">
                <Text>
                  Already have an account?-{" "}
                  <NextLink href="/login">Log in</NextLink>{" "}
                </Text>
              </Box>
            </Box>
            <Box className="login-form-img-wrapper">
              <Img src="/signup-img.png" alt="login-img" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default Signup;
